import Layout from "components/Layouts/default"

export default function Index({ error }) {
  return <Layout>{error ? error.message : "An unknown error occurred"}</Layout>
}
